import React, { FC, useEffect, useState } from 'react';
import { isAllowedToPublishToNetwork } from '../../../../store/authentication/actions';
import { SetLiveInCollectionPopup } from './SetLiveInCollectionPopup';
import { LegalConfirmationPopup } from './LegalConfirmationPopup';
import { CountryOut } from '../../../../store/apiLibx';
import { AuthenticationState, SpocState } from '../../../../store/authentication/state';
import { SetLiveOnLibXChangePopup } from './SetLiveOnLibXChangePopup';

const STEP_1 = 'STEP_1';
const STEP_2 = 'STEP_2';
const STEP_3 = 'STEP_3';

type SharingOptions = {
    sharingOptions: string;
    targetSpoc: string | undefined;
    licenseOption: string | undefined;
};
interface Props {
    onAbort: () => void;
    onPublish: (publishOptions: SharingOptions) => void;
    countries?: CountryOut[];
    spocId: string;
    authentication: AuthenticationState;
    show: boolean;
}
export const LCPublishWorkflow: FC<Props> = ({
    onAbort = () => {},
    onPublish = () => {},
    countries = [],
    authentication,
    show
}) => {
    const [step, setStep] = useState<string>();
    const [targetSpoc, setTargetSpoc] = useState<string>();
    const [licenseOption, setLicenseOption] = useState<string>();
    const [licenseAccepted, setLicenseAccepted] = useState(false);
    useEffect(() => {
        if (show) {
            setStep(STEP_1);
        }
        return () => {
            setStep(undefined);
        };
    }, [show]);

    function onConfirmLicense(selectedLicenseOption) {
        setStep(STEP_2);
        setLicenseOption(selectedLicenseOption);
        setLicenseAccepted(true);
    }

    function onSetLive(selectedSpoc) {
        setTargetSpoc(selectedSpoc);
        setStep(STEP_3);
    }

    function onFinish(sharingOptions: string) {
        const publishOptions = {
            sharingOptions,
            targetSpoc,
            licenseOption,
            licenseAccepted
        };
        onPublish(publishOptions);
    }

    type Spoc = Pick<SpocState, 'id' | 'name'>;

    const spocs: Spoc[] = [];
    let defaultCountryCode: string | undefined;
    const spocId = authentication?.spoc?.id;
    const allSpocs = authentication?.spocs ?? [];

    if (spocId.indexOf('PARTNER') >= 0) {
        const partner = allSpocs?.find(s => s.id === spocId);
        spocs.push({ id: partner?.id ?? '', name: partner?.name ?? '' });

        if (partner) {
            spocs.push(...partner.sites.filter(s => s.id === spocId).map(s => ({ id: s.id, name: s.name })));
        }

        defaultCountryCode = partner?.taxCountry;
    } else {
        const partner = allSpocs?.find(s => s.sites.find(site => site.id === spocId));

        if (isAllowedToPublishToNetwork(authentication)) {
            if (partner?.id && partner.name) {
                spocs.push({
                    id: partner.id,
                    name: partner.name
                });
            } else {
                const partner = authentication.spoc;
                spocs.push({ id: partner.id, name: partner.name });
            }
        }
        const site = partner?.sites.find(s => s.id === spocId);
        spocs.push({ id: site?.id ?? '', name: site?.name ?? '' });

        defaultCountryCode = partner?.taxCountry || site?.taxCountry;
    }

    return (
        <>
            <LegalConfirmationPopup show={step === STEP_1} onAbort={onAbort} onConfirmLicense={onConfirmLicense} />
            <SetLiveInCollectionPopup spocs={spocs} show={step === STEP_2} onAbort={onAbort} onSetLive={onSetLive} />
            <SetLiveOnLibXChangePopup
                defaultCountryCode={defaultCountryCode}
                countries={countries || []}
                show={step === STEP_3}
                onAbort={onAbort}
                onFinish={onFinish}
            />
        </>
    );
};
